import { Base, importWhenVisible } from '@studiometa/js-toolkit';

/**
 * Collection.
 *
 */
export default class Collection extends Base {
  static config = {
    name: 'Collection',
    components: {
      Facets: (app) => importWhenVisible(() => import('./Facets/index.js'), 'Facets', app),
    },
  };
}
